import io from 'socket.io-client';
import { getUrl } from '../utils/helper';

const STRAPI_ENDPOINT = getUrl();

export const socket = io(STRAPI_ENDPOINT, {
	withCredentials: true,
	transports: ['websocket'],
});
